(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-template"]) return;
  try {
    
    const getpagi = document.querySelector('.AjaxinatePagination');
    if(typeof(getpagi) !== "undefined" && getpagi !== null){
      document.addEventListener("DOMContentLoaded", function() {
        const elem = getpagi.getAttribute('data-pagination');
        var endlessScroll = new Ajaxinate({
          container: '.AjaxinateLoop',
          pagination: '.AjaxinatePagination',
          loadingText: '<span class="loader-line"></span>',
          method: elem == 'scroll' ? 'scroll' : 'click'
        });
      });
    }
    
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parallax-banner"] && !Shopify.designMode) return;
  try {
    
  class ParallaxImage extends HTMLElement {
    constructor() {
      super();
      
    }
  connectedCallback() {
    const sectionId = this.getAttribute('section-id');
    const image = this.querySelector('img');
    const aosAnimation = this.getAttribute('data-aos');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          window.addEventListener('scroll', this.parallaxEffect);
        } else {
          window.removeEventListener('scroll', this.parallaxEffect);
        }
      });
    });

    const section = document.getElementById(sectionId);
    observer.observe(section);

    const imageContainer = this;
    imageContainer.style.transform = 'translateY(0)';

    this.parallaxEffect = () => {
      const scrollPosition = window.pageYOffset;
      const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
      const parallaxValue = (scrollPosition / maxScroll) * 50;
      image.style.transform = `translateY(-${parallaxValue}%) scale(1.2)`;
    };

  }
}

customElements.define('parallax-image', ParallaxImage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-content"]) return;
  try {
    
  class productPairs extends HTMLElement {
    connectedCallback() {
      fetch(this.dataset.url).
      then((response) => {
        if (!response.ok) {
          throw new Error("HTTP error! Status: ".concat(response.status));
        }
        return response.text();
      }).
      then((response) => {
        var frag = document.createDocumentFragment(),
          fetchedContent = document.createElement('div');
        frag.appendChild(fetchedContent);
        fetchedContent.innerHTML = response;

        var replacementContent = fetchedContent.querySelector("[data-id=\"".concat(CSS.escape(this.dataset.id), "\"]"));
        if (replacementContent) {
          this.innerHTML = replacementContent.innerHTML;
        }
      });
    }
  }

  customElements.define('product-pairs', productPairs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
 
class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
              const swiperContainer = this.querySelector('.swiper-container');
              const getID = swiperContainer.getAttribute("data-id");
              const swiperID = this.querySelector(`.swipercol-${getID}`);
              const spaceBetween = parseInt(swiperContainer.getAttribute('data-space-between'), 10);
              const perviewDesktop = swiperContainer.getAttribute('data-perview-desktop');
              if (swiperContainer) {
                new Swiper(swiperContainer, {
                  slidesPerView: "auto",
                  freeMode: false,
                  autoHeight: true,
                  calculateHeight:true,
                  freeModeSticky: true,
                  centeredSlides: false,
                  grabCursor: true,
                  watchSlidesVisibility: true,
                  watchSlidesProgress: true,
                  preloadImages: true,
                  updateOnImagesReady: true,
                  spaceBetween: spaceBetween,
                  observer: true,
                  observeParents: true,
                  parallax:true,
                  a11y: true,
                  keyboard: {
                    enabled: true,
                  },
                  breakpoints: {
                    320: {
                      slidesPerView: 2,
                      spaceBetween: 20
                    },
                    576: {
                      slidesPerView: 2,
                    },
                    768: {
                      slidesPerView: 3,
                    },
                    992: {
                      slidesPerView: perviewDesktop,
                    }
                  },
                  scrollbar: {
                    el: this.querySelector(".swiper-scrollbar"),
                  },
                  navigation: {
                    nextEl: this.querySelector(".swiper-button-next"),
                    prevEl: this.querySelector(".swiper-button-prev"),
                  },
                });
              } else {
                console.error('No element with class "swiper-container" found.');
              }
            }
            jdgm.customizeBadges();
            if (window.SPR && theme.review ) {
              if ($('.shopify-product-reviews-badge').length > 0) {
                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
              };
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 500px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-1"]) return;
  try {
    

class productPairsRight extends HTMLElement {

  connectedCallback() {

    fetch(this.dataset.url).

    then((response) => {

      if (!response.ok) {

        throw new Error("HTTP error! Status: ".concat(response.status));

      }

      return response.text();

    }).

    then((response) => {

      var frag = document.createDocumentFragment(),

        fetchedContent = document.createElement('div');

      frag.appendChild(fetchedContent);

      fetchedContent.innerHTML = response;



      var replacementContent = fetchedContent.querySelector("[data-id=\"".concat(CSS.escape(this.dataset.id), "\"]"));

      if (replacementContent) {

        this.innerHTML = replacementContent.innerHTML;

      }

    });

  }

}



customElements.define('product-pairsright', productPairsRight);



class BuyNow extends HTMLElement {

  constructor() {

    super();

    this.addEventListener('click', this.handleClick.bind(this));

  }



  connectedCallback() {

    this.checkAgreement();

  }



  handleClick(event) {

    const agreeCheckbox = this.querySelector('.checkbox__input');

    const checkoutButton = this.querySelector('.product-form__buynow');

    

    if (event.target === agreeCheckbox || event.target === this.querySelector('.checkbox__label')) {

      if (agreeCheckbox.checked) {

        checkoutButton.classList.remove('disabled');

      } else {

        checkoutButton.classList.add('disabled');

      }

    }

  }

  checkAgreement() {

    const agreeCheckbox = this.querySelector('.checkbox__input');

    return agreeCheckbox.checked;

  }

}



customElements.define('buy-now', BuyNow);



var initPhotoSwipeFromDOM = function(gallerySelector) {



// parse slide data (url, title, size ...) from DOM elements 

// (children of gallerySelector)

var parseThumbnailElements = function(el) {

  var thumbElements = Array.prototype.slice.call(document.querySelectorAll('.photo-image')),

    numNodes = thumbElements.length,

    items = [],

    figureEl,

    linkEl,

    size,

    item;



  for (var i = 0; i < numNodes; i++) {



    figureEl = thumbElements[i]; // <figure> element

    // include only element nodes 

    if (figureEl.nodeType !== 1) {

      continue;

    }



    linkEl = figureEl.children[0]; // <a> element

    if(linkEl.getAttribute('data-size')){

      size =  linkEl.getAttribute('data-size').split('x') ;

    }else{

      size =  [] ;

    }

    

    



    // create slide object

    item = {

      src: linkEl.getAttribute('href'),

      w: parseInt(size[0], 10),

      h: parseInt(size[1], 10)

    };







    if (figureEl.children.length > 1) {

      // <figcaption> content

      item.title = figureEl.children[1].innerHTML;

    }



    if (linkEl.children.length > 0) {

      // thumbnail element, retrieving thumbnail url

      item.msrc = linkEl.children[0].getAttribute('data-phototview');

    }



    item.el = figureEl; // save link to element for getThumbBoundsFn

    items.push(item);

  }



  return items;

};



// find nearest parent element

var closest = function closest(el, fn) {

  return el && (fn(el) ? el : closest(el.parentNode, fn));

};



// triggers when user clicks on thumbnail

var onThumbnailsClick = function(e) {

  e = e || window.event;

  e.preventDefault ? e.preventDefault() : e.returnValue = false;



  var eTarget = e.target || e.srcElement;



  // find root element of slide

  var clickedListItem = closest(eTarget, function(el) {

    return (el.tagName && el.tagName.toUpperCase() === 'FIGURE');

  });



  if (!clickedListItem) {

    return;

  }



  // find index of clicked item by looping through all child nodes

  // alternatively, you may define index via data- attribute

  var clickedGallery = clickedListItem.parentNode,

    childNodes = clickedListItem.parentNode.childNodes,

    numChildNodes = childNodes.length,

    nodeIndex = 0,

    index;



  for (var i = 0; i < numChildNodes; i++) {

    if (childNodes[i].nodeType !== 1) {

      continue;

    }



    if (childNodes[i] === clickedListItem) {

      index = nodeIndex;

      break;

    }

    nodeIndex++;

  }







  if (index >= 0) {

    // open PhotoSwipe if valid index found

    openPhotoSwipe(index, clickedGallery);

  }

  return false;

};



// parse picture index and gallery index from URL (#&pid=1&gid=2)

var photoswipeParseHash = function() {

  var hash = window.location.hash.substring(1),

    params = {};



  if (hash.length < 5) {

    return params;

  }



  var vars = hash.split('&');

  for (var i = 0; i < vars.length; i++) {

    if (!vars[i]) {

      continue;

    }

    var pair = vars[i].split('=');

    if (pair.length < 2) {

      continue;

    }

    params[pair[0]] = pair[1];

  }



  if (params.gid) {

    params.gid = parseInt(params.gid, 10);

  }



  return params;

};



var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {

  var pswpElement = document.querySelectorAll('.pswp')[0],

    gallery,

    options,

    items;



  items = parseThumbnailElements(galleryElement);



  // define options (if needed)

  options = {

    maxSpreadZoom: 1, 

    bgOpacity: 0.7,

    zoomEl: true,

    history: false,

    pinchToClose: false,

    closeOnScroll: false,



    // define gallery index (for URL)

    galleryUID: galleryElement.getAttribute('data-pswp-uid'),



  };



  // PhotoSwipe opened from URL

  if (fromURL) {

    if (options.galleryPIDs) {

      // parse real index when custom PIDs are used 

      // http://photoswipe.com/documentation/faq.html#custom-pid-in-url

      for (var j = 0; j < items.length; j++) {

        if (items[j].pid == index) {

          options.index = j;

          break;

        }

      }

    } else {

      // in URL indexes start from 1

      options.index = parseInt(index, 10) - 1;

    }

  } else {

    options.index = parseInt(index, 10);

  }



  // exit if index not found

  if (isNaN(options.index)) {

    return;

  }



  if (disableAnimation) {

    options.showAnimationDuration = 0;

  }



  // Pass data to PhotoSwipe and initialize it

  gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);

  gallery.init();

};



// loop through all gallery elements and bind events

var galleryElements = document.querySelectorAll(gallerySelector);



for (var i = 0, l = galleryElements.length; i < l; i++) {

  galleryElements[i].setAttribute('data-pswp-uid', i + 1);

  galleryElements[i].onclick = onThumbnailsClick;

}



// Parse URL and open gallery if it contains #&pid=3&gid=1

var hashData = photoswipeParseHash();

if (hashData.pid && hashData.gid) {

  openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);

}

};



// execute above function

initPhotoSwipeFromDOM('.my-gallery');




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline"] && !Shopify.designMode) return;
  try {
    
  !function(){function e(e){this.element=e,this.blocks=this.element.getElementsByClassName("js-cd-block"),this.images=this.element.getElementsByClassName("js-cd-img"),this.contents=this.element.getElementsByClassName("js-cd-content"),this.offset=.8,this.hideBlocks()}e.prototype.hideBlocks=function(){if(!(!1 in document.documentElement))for(var e,t=this,s=0;s<this.blocks.length;s++)e=s,t.blocks[e].getBoundingClientRect().top>window.innerHeight*t.offset&&(t.images[e].classList.add("cd-is-hidden"),t.contents[e].classList.add("cd-is-hidden"))},e.prototype.showBlocks=function(){if(!(!1 in document.documentElement))for(var e,t=this,s=0;s<this.blocks.length;s++)e=s,t.contents[e].classList.contains("cd-is-hidden")&&t.blocks[e].getBoundingClientRect().top<=window.innerHeight*t.offset&&(t.images[e].classList.add("or-timeline__img--bounce-in"),t.contents[e].classList.add("or-timeline__content--bounce-in"),t.images[e].classList.remove("cd-is-hidden"),t.contents[e].classList.remove("cd-is-hidden"))};var t,s=document.getElementsByClassName("js-or-timeline"),n=[],i=!1;if(s.length>0){for(var o=0;o<s.length;o++)t=o,n.push(new e(s[t]));window.addEventListener("scroll",function(e){i||(i=!0,window.requestAnimationFrame?window.requestAnimationFrame(c):setTimeout(c,250))})}function c(){n.forEach(function(e){e.showBlocks()}),i=!1}}();

  } catch(e) { console.error(e); }
})();
})();
